const seoPermalink = (item) => {
  const permalink = item.name.trim().replace(/\s+|\-+/g, "-")
  return `${item.id}-${permalink}`;
}

export { seoPermalink }
